const esAr = {
  comunícate: 'comunicate',
  elminara: 'elminará',
} as const;

export default esAr;
